// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Production24FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Production24Filled: FC<Production24FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path
                d="M9.166 21.562c.031.25.248.438.504.438h4.66a.505.505 0 0 0 .504-.438l.318-2.518a.5.5 0 0 1 .246-.369l.32-.187.01-.005.424-.236a.515.515 0 0 1 .449-.025l2.336.98c.236.098.51.008.639-.211l2.33-3.985a.495.495 0 0 0-.131-.647l-2.047-1.534a.498.498 0 0 1-.2-.398v-.183c0-.092 0-.273.016-.684a.495.495 0 0 1 .199-.377L21.8 9.64a.495.495 0 0 0 .132-.647L19.6 5.008a.512.512 0 0 0-.637-.211l-2.37.985a.507.507 0 0 1-.436-.021 10.444 10.444 0 0 1-.43-.244c-.099-.06-.22-.132-.324-.192a.506.506 0 0 1-.251-.374l-.318-2.513A.505.505 0 0 0 14.33 2H9.67a.505.505 0 0 0-.504.438l-.318 2.52a.501.501 0 0 1-.243.368l-.209.124-.167.097c-.136.08-.25.14-.384.213a.515.515 0 0 1-.44.021l-2.368-.984a.512.512 0 0 0-.637.211L2.068 8.994a.495.495 0 0 0 .132.647l2.047 1.534c.126.095.2.242.2.398v.854a.498.498 0 0 1-.2.398L2.2 14.36a.495.495 0 0 0-.132.647L4.4 18.992c.128.219.401.31.637.211l2.357-.98a.515.515 0 0 1 .456.03l.345.2.008.005.391.218a.5.5 0 0 1 .255.374l.317 2.512ZM12 15.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Production24Filled;
